import angular from 'angular';
import HelpService from './help.service';
import helpButtonComponent from './help-button/help-button.component';

/**
 * Timeclerk Help Subsystem
 *
 * Content and UI live under client/help/ so guidance stays separate from
 * feature implementation. Use <help-button topic="timesheet"></help-button>
 * or HelpService.open('timesheet') from any page.
 */
let helpModule = angular.module('app.help', [])
  .service('HelpService', HelpService)
  .component('helpButton', helpButtonComponent);

export default helpModule;



// WEBPACK FOOTER //
// ./client/help/help.js